// Plays a notification sound using Web Audio API (no file needed).
// Browsers start AudioContexts in a "suspended" state until the user has
// interacted with the page — a context created inside a WebSocket message
// handler stays suspended and plays nothing. So we keep one shared context
// and unlock it on the first user gesture.

let sharedCtx: AudioContext | null = null;

function getContext(): AudioContext | null {
  if (!sharedCtx) {
    try {
      sharedCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    } catch {
      return null;
    }
    const unlock = () => { sharedCtx?.resume().catch(() => {}); };
    window.addEventListener("pointerdown", unlock, { once: true });
    window.addEventListener("keydown", unlock, { once: true });
  }
  return sharedCtx;
}

export function playNotificationSound() {
  const ctx = getContext();
  if (!ctx) return;

  const play = () => {
    try {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();

      oscillator.connect(gain);
      gain.connect(ctx.destination);

      // Two-tone notification: high-low
      oscillator.frequency.value = 880;
      oscillator.type = "sine";

      gain.gain.setValueAtTime(0.3, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.15);

      oscillator.start(ctx.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(660, ctx.currentTime + 0.1);
      oscillator.stop(ctx.currentTime + 0.15);
    } catch (e) {
      console.log("Audio playback failed:", e);
    }
  };

  if (ctx.state === "suspended") {
    // Try to resume (works if the user has interacted); skip silently if not.
    ctx.resume().then(play).catch(() => {});
  } else {
    play();
  }
}
